<div class="smsbtn" *ngIf="items && items.length>0">

  <ssg-button label="{{ item.Name }}" *ngFor="let item of items"
              (click)="addItem(item.Name, input)"
              color="accent"
              buttontype="button"
              size="medium"></ssg-button>

</div>
<div [formGroup]="group">
<textarea [cols]="cols"
          [formControl]="formControl()"
          [rows]="rows"
          [required]="required"
          (ngModelChange)='onChange($event)'
          #input
          [placeholder]="placeholder">
</textarea>
</div>
